module.exports = __webpack_public_path__ + "30434cc17f133ed03abae34538aa2949.MP3";